<template>
  <div class="partner-registration-form-footer">
    <span v-html="footerText"></span>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const footerText = computed(() => {
  const termsLinkText = t('partner.registration.form.footer.linkText')
  const termsUrl = '/terms-supplier/'
  const baseText = t('partner.registration.form.footer.helpText')

  // Replace {termsLink} placeholder with actual link
  return baseText.replace(
    'termsLink',
    `<a href="${termsUrl}" style="color: #CCED3A;" target="_blank">${termsLinkText}</a>`
  )
})
</script>

<style lang="postcss" scoped>
.partner-registration-form-footer {
  @apply text-white text-sm my-12 text-center;
}

.partner-registration-form-footer__link {
  @apply text-white hover:underline;
}
</style>
